import Bugsnag from '@bugsnag/js';
import React from 'react';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import BugsnagPerformance from '@bugsnag/browser-performance';
import getConfig from 'next/config';
import { IS_CLIENT } from './app/utils';

const { BUGSNAG_KEY, BS_ENV, APP_VERSION } = getConfig().publicRuntimeConfig;

const detectDomTampering = () => {
  if (!IS_CLIENT) return {};
  const signs: string[] = [];
  if (document.querySelector('grammarly-extension, grammarly-desktop-integration')) signs.push('grammarly');
  if (document.querySelector('[data-lastpass-icon-root], [data-lastpass-root]')) signs.push('lastpass');
  if (document.querySelector('[data-dashlane-rid], [data-dashlanecreated]')) signs.push('dashlane');
  if (document.querySelector('font[style], font[class]')) signs.push('auto-translate');
  if (document.querySelector('[class*="ytp-"], [id*="google_ads"]')) signs.push('google-injected');
  if (document.querySelector('#credential_picker_container')) signs.push('google-one-tap');
  if (document.documentElement.classList.contains('translated-ltr')) signs.push('chrome-translate');
  if (document.querySelector('html[lang] > body font')) signs.push('safari-translate');
  return { detected: signs.length > 0, signs: signs.join(', ') || 'none' };
};

const init = () => {
  Bugsnag.start({
    apiKey: BUGSNAG_KEY,
    appVersion: APP_VERSION || '0.2.1',
    appType: IS_CLIENT ? 'client' : 'server',
    releaseStage: BS_ENV || 'development',
    enabledReleaseStages: ['staging', 'production'],
    plugins: [new BugsnagPluginReact(React)],
    onError: (event) => {
      const msg = event.errors[0]?.errorMessage || '';
      const isHydrationError =
        msg.includes('Minified React error #418;') ||
        msg.includes('Minified React error #423;') ||
        msg.includes('Minified React error #425;');
      if (isHydrationError && IS_CLIENT) {
        const tampering = detectDomTampering();
        event.addMetadata('hydration', {
          ...tampering,
          url: window.location.href,
          viewport: `${window.innerWidth}x${window.innerHeight}`,
          userAgent: navigator.userAgent,
        });
        // eslint-disable-next-line no-param-reassign
        event.groupingHash = 'react-hydration-mismatch';
      }
    },
  });
  BugsnagPerformance.start({
    apiKey: BUGSNAG_KEY,
    appVersion: APP_VERSION || '0.2.1',
    releaseStage: BS_ENV || 'development',
    enabledReleaseStages: ['staging', 'production'],
  });
};

export default init;

export const telemetry = (label: string, payload = {}) => {
  if (IS_CLIENT) {
    Bugsnag.leaveBreadcrumb(label, payload);
  }
};

export const logError = (error) => {
  console.warn(error);
  Bugsnag.notify(error);
};
